module.exports = __webpack_public_path__ + "img/logo-fifalotto-white5-gt.94013877.png";